
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/signal/tuning-rules",
      function () {
        return require("private-next-pages/docs/signal/tuning-rules.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/signal/tuning-rules"])
      });
    }
  